import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../store';
import { sessionExpired } from '../store/login/login.actions';
import { AuthService } from '../modules/shared/services/auth.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

    constructor(private store: Store<AppState>, private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Attach credentials to all requests targeting the API (cross-origin CORS).
        if (request.url.startsWith(environment.apiUrl)) {
            request = request.clone({ withCredentials: true });
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && request.url.startsWith(environment.apiUrl)) {
                    if (!this.authService.sessionBootstrapped) {
                        // Pre-bootstrap 401: redirect immediately to external login.
                        this.authService.redirectToLogin();
                    } else if (!this.authService.sessionExpiredInProgress) {
                        // Post-bootstrap 401: show session-expired modal once.
                        // Set the flag synchronously before dispatch to prevent duplicate
                        // handling when multiple concurrent requests fail with 401.
                        this.authService.sessionExpiredInProgress = true;
                        this.store.dispatch(sessionExpired());
                    }
                }
                return throwError(() => error);
            })
        );
    }
}
